import './Home.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";

import A from 'components/A';
import Button from 'components/Button';
import Logo from 'components/Logo';
import Nav from 'components/Nav';
import NavItem from 'components/NavItem';
import H1 from 'components/H1';
import H2 from 'components/H2';
import Icon from 'components/Icon';
import MainFooter from 'components/MainFooter';
import PricingGrid from 'components/PricingGrid';

class Home extends React.Component {
    componentWillMount() {
        document.body.classList.add('home-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('home-page');
        document.body.classList.remove('open-menu');
    }

    _openCloseMenu() {
        document.body.classList.toggle('open-menu');
    }

    render() {
        return (
            <div className="home">
                <header className="c-main-header">
                    <Logo />

                    <Button className="open-close-menu"
                            id="openCloseMenu"
                            noStyles
                            onClick={this._openCloseMenu.bind(this)}>
                        <div className="open-close-menu_inner">
                            <div className="menu-line line1"></div>
                            <div className="menu-line line2">
                                <div className="menu-line line4"></div>
                            </div>
                            <div className="menu-line line3"></div>
                        </div>
                    </Button>

                    <Nav className="c-main-nav">
                        <ul className="c-nav__menu c-main-nav__menu"
                            onClick={this._openCloseMenu.bind(this)}>
                            <NavItem>
                                <A className="c-nav-item__link"
                                   href="#about">
                                    About
                                </A>
                            </NavItem>
                            <NavItem>
                                <A className="c-nav-item__link"
                                   href="#pricing">
                                    Pricing
                                </A>
                            </NavItem>
                            <li className="c-main-nav__button--wrapper">
                                <A className="c-button a-button--primary"
                                   to="/request-invitation">
                                    Request Invite
                                </A>
                            </li>
                            <li className="c-main-nav__button--wrapper">
                                <A className="c-button"
                                   to="/login">
                                    Log In
                                </A>
                            </li>
                        </ul>
                    </Nav>
                </header>

                <section className="home__hero">
                    <div className="home__hero--inner">
                        <H1>
                            Creativity, curated.
                        </H1>
                        <H2>
                            The Hunt Agency is an invite-only curation of the area’s leading advertising and marketing freelancers. Our bar is high—you know, like your expectations.
                        </H2>
                        <div className="hero__button--wrapper">
                            <A className="c-button"
                               to="/request-invitation">
                                For Businesses
                            </A>
                            <A className="c-button a-button--primary"
                               to="/request-invitation">
                                For Freelancers
                            </A>
                        </div>
                    </div>
                </section>

                <section className="home__screenshots">
                    <div className="screenshots--wrapper">
                        <div>
                            <img srcSet="/img/screenshot-front.jpg,
                                         /img/screenshot-front_2x.jpg 2x"
                                 src="/img/screenshot-front.jpg" alt="A preview of our app" />
                        </div>
                        <div>
                            <img srcSet="/img/screenshot-back.jpg,
                                         /img/screenshot-back_2x.jpg 2x"
                                 src="/img/screenshot-back.jpg" alt="A preview of our app" />
                        </div>
                    </div>
                    <div>
                        The Hunt is available on desktop and mobile devices.
                    </div>
                </section>

                <section className="home__about" id="about">
                    <div className="home__about--inner">
                        <H1>
                            <Icon type="about" /> About
                        </H1>
                        <H2>
                            What can we say? We know people.
                        </H2>
                        <div>
                            <p>Traditional tactics for finding freelance talent not working? We figured. These days, top shelf creatives rely less on ads and posts and more on word of mouth and connections. That’s where we come in. We’re The Hunt Agency (hi, nice to meet you), industry pros who’ve put in a whopping 45 combined years in advertising and marketing agencies big and small. Throughout our time, we continually tumbled into the same frustrating problem: how to find reputable freelancers in a pinch.</p>
                            <p>So, what did we do? The same ole. We’d text or email colleagues for contacts, we’d occasionally fork over the commission fees for a recruiter or we’d use a vague online service, cross our fingers and hope the algorithm fairies would make our freelance wishes come true.</p>
                            <p>Thus, The Hunt Agency began. A better, simpler, go-ahead-and-breathe-easier way to do things. We’re a real-time resource that gives companies immediate access to top tier freelancers who can get the job done. And not just any freelancer. Vetted freelancers. Trusted freelancers. We’re talking the best of the very, very best freelancers.</p>
                            <p>Are we a recruiting firm? Nah. Another job board? Nope.<br />
                            We just love connecting people with the kind of people who can leave clients downright giddy. Time and time again.</p>
                        </div>
                    </div>
                </section>

                <section className="home__pricing" id="pricing">
                    <div className="home__pricing--inner">
                        <H1>
                            <Icon type="pricing" /> Pricing
                        </H1>
                        <H2>
                            To get started, pick the plan that's best for you and start your free 24-hour trial.
                        </H2>
                        <PricingGrid
                            buttonText="Request an invite"
                            handleClick={() => this.props.changeLocation('/request-invitation')}
                        />
                    </div>
                </section>

                <MainFooter pathname="/" />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Home/index.js